import React from 'react';

import AdditionalInfo from './AdditionalInfo';
import BeforeYouStart from './BeforeYouStart';
import BetaTestingUpdated from './BetaTestingUpdated';
import Breadcrumbs from './Breadcrumbs';
import Intro from './Intro';
import MoreAboutOurChatbot from './MoreAboutOurChatbot';

export default function LeftColumnContent() {
  return (
    <>
      <Breadcrumbs />
      <Intro />
      <BetaTestingUpdated />
      <BeforeYouStart />
      <AdditionalInfo />
      <MoreAboutOurChatbot />
    </>
  );
}
